/**
 * Web Style Import
 *
 */

import './style/dnb-logo.scss'
